import { VueConstructor } from 'vue'

// Builder Sidepanels
import SidebarSettingsView from '@/views/builder/SidebarSettingsView.vue'
import VisualisationSettingsView from '@/views/builder/VisualisationSettingsView.vue'
import StoryEditorView from '@/views/builder/StoryEditorView.vue'
import MapSettingsView from '@/views/builder/MapSettingsView.vue'
import GeneralSettingsView from '@/views/builder/GeneralSettingsView.vue'
import OtherSettingsView from '@/views/builder/OtherSettingsView.vue'

// Sidebar Settings
import TabSettings from '@/components/builder/TabSettings/TabSettings.vue'
import PiechartSettings from '@/components/builder/PiechartSettings/PiechartSettings.vue'
import SummaryTableSettings from '@/components/builder/SummaryTableSettings/SummaryTableSettings.vue'
import ComparisonGraphSettings from '@/components/builder/ComparisonGraphSettings/ComparisonGraphSettings.vue'

// General Settings
import GeneralSettings from '@/components/builder/GeneralSettings/GeneralSettings.vue'
import PopupSettings from '@/components/builder/PopupSettings/PopupSettings.vue'
import NumericFormatting from '@/components/builder/NumericFormatting.vue'
import NavButtonsSettings from '@/components/builder/NavButtonsSettings/NavButtonsSettings.vue'
import TitleDescriptionSettings from '@/components/builder/TitleDescriptionSettings.vue'
import FieldCalculator from '@/components/builder/FieldCalculator/FieldCalculator.vue'

// Optional Features/Other Settings
import SearchSettings from '@/components/builder/SearchSettings/SearchSettings.vue'
import FilterSettings from '@/components/builder/FilterSettings/FilterSettings.vue'
import SplashScreenSettings from '@/components/builder/SplashScreenSettings.vue'
import FaqSettings from '@/components/builder/FaqSettings.vue'
import DownloadSettings from '@/components/builder/DownloadSettings.vue'

import {
  ROUTE_SIDEBAR_SETTINGS,
  ROUTE_VISUALISATION_SETTINGS,
  ROUTE_STORY_EDITOR,
  ROUTE_MAP_SETTINGS,
  ROUTE_GENERAL_SETTINGS,
  ROUTE_OTHER_SETTINGS,
  VIEW_PROJECTS,
  EDIT_MAP_VIEW,
  VIEW_VISUAL,
} from '@/constants'
import { AppType, AppTypes } from '@/types'

export interface BuilderSidepanel {
  sidepanel: string
  mainpanel: string
  component: VueConstructor
  title: string
  icon: string | string[]
  appTypes: AppType[]
  mapOnly?: boolean
}

export const BUILDER_SIDEPANELS: BuilderSidepanel[] = [
  {
    sidepanel: ROUTE_SIDEBAR_SETTINGS,
    component: SidebarSettingsView,
    mainpanel: VIEW_PROJECTS,
    title: 'Sidebar Settings',
    icon: 'bars',
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    sidepanel: ROUTE_VISUALISATION_SETTINGS,
    component: VisualisationSettingsView,
    mainpanel: VIEW_VISUAL,
    title: 'Visualisation Settings',
    icon: ['custom', 'bubbles'],
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    sidepanel: ROUTE_STORY_EDITOR,
    component: StoryEditorView,
    mainpanel: VIEW_PROJECTS,
    title: 'Story Editor',
    icon: 'pen-nib',
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    sidepanel: ROUTE_MAP_SETTINGS,
    component: MapSettingsView,
    mainpanel: EDIT_MAP_VIEW,
    title: 'Map Settings',
    icon: 'map-marked',
    appTypes: [AppTypes.BUBBLES],
    mapOnly: true,
  },
  {
    sidepanel: ROUTE_GENERAL_SETTINGS,
    component: GeneralSettingsView,
    mainpanel: VIEW_PROJECTS,
    title: 'General Settings',
    icon: 'cogs',
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    sidepanel: ROUTE_OTHER_SETTINGS,
    component: OtherSettingsView,
    mainpanel: VIEW_PROJECTS,
    title: 'Optional Features',
    icon: 'check-square',
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
]

export interface SettingsView {
  component: VueConstructor
  appTypes: AppType[]
}

export const SIDEBAR_SETTINGS: SettingsView[] = [
  {
    component: TabSettings,
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    component: PiechartSettings,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: SummaryTableSettings,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: ComparisonGraphSettings,
    appTypes: [AppTypes.BUBBLES],
  },
]

export const GENERAL_SETTINGS: SettingsView[] = [
  {
    component: GeneralSettings,
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    component: PopupSettings,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: NumericFormatting,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: NavButtonsSettings,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: TitleDescriptionSettings,
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    component: FieldCalculator,
    appTypes: [AppTypes.BUBBLES],
  },
]

export const OTHER_SETTINGS: SettingsView[] = [
  {
    component: SearchSettings,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: FilterSettings,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: SplashScreenSettings,
    appTypes: [AppTypes.BUBBLES, AppTypes.CONSOLIDATED],
  },
  {
    component: FaqSettings,
    appTypes: [AppTypes.BUBBLES],
  },
  {
    component: DownloadSettings,
    appTypes: [AppTypes.BUBBLES],
  },
]
